import { createRootRouteWithContext, Outlet, useLocation } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { AppLayout } from '@/components/layout/AppLayout';
import { isPublicAuthPath } from '@/lib/site-paths';

export interface RouterContext {
  queryClient: QueryClient;
}

function isPublicPath(pathname: string): boolean {
  return isPublicAuthPath(pathname);
}

export const rootRoute = createRootRouteWithContext<RouterContext>()({
  component: RootShell,
});

function RootShell() {
  const location = useLocation();

  if (isPublicPath(location.pathname)) {
    return (
      <div data-ai-id="public-auth-route">
        <Outlet />
      </div>
    );
  }

  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}
